//TODOPERF - we may use separate calls for different filters lowering the system load even more
import * as CONST from '@/constants'
import Vue from 'vue'
import axios from '@/utils/axios_iface'
import * as utils from '@/utils/main_utils'
import * as api_utils from '@/utils/api_utils'

function find_actual_record(state, getters, field) {
  var actual_record = state.collections[field.data.collection_id]
  if (actual_record && field.data.brand_required) {
    var brand_string = field.data.brand_id || getters.currentBrandId
    if (!brand_string) {
      utils.generate_error(
        `${field.field_id} collection requires brand, but brand is not in context`
      )
    }
    actual_record = actual_record.by_brand[brand_string]
    if (actual_record && field.data.store_required) {
      var store_string = field.data.store_id || getters.currentStoreId
      if (!store_string) {
        utils.generate_error(
          `${field.field_id} collection requires store, but store is not in context`
        )
      }
      actual_record = actual_record.by_store[store_string]
    }
  }
  return actual_record
}

export default {
  state: {
    collections: {},
  },
  mutations: {
    SET_COLLECTION_TIMERS_TO_1970: (state) => {
      for (var col in state.collections) {
        if (!state.collections[col].keep_on_page_change) {
          state.collections[col].last_success_load_time = 0
        }
        for (var brand in state.collections[col].by_brand) {
          if (!state.collections[col].by_brand[brand].keep_on_page_change) {
            state.collections[col].by_brand[brand].last_success_load_time = 0
          }
          for (var store in state.collections[col].by_brand[brand].by_store) {
            if (
              !state.collections[col].by_brand[brand].by_store[store]
                .keep_on_page_change
            ) {
              state.collections[col].by_brand[brand].by_store[
                store
              ].last_success_load_time = 0
            }
          }
        }
      }
    },
    RESET_COLLECTION_BY_ID: (state, collectionId) => {
      if (state.collections && state.collections[collectionId]) {
        Vue.delete(state.collections, collectionId)
      }
    },
    SET_COLLECTION_INITIAL_IF_REQUIRED: (
      state,
      { api_root_url, field, currentBrandId, currentStoreId }
    ) => {
      let url = {}
      let model = '/model'
      if (field.data.no_model) {
        model = ''
      }
      //TODOIMPR cleanup cached collections
      if (!(field.data.collection_id in state.collections)) {
        url = {}

        url['url'] = `${api_root_url}${model}/${field.data.collection_id}`
        if (field.data.entities) {
          for (const key in field.data.entities) {
            url['url'] += '/' + key + '/' + field.data.entities[key]
          }
        }
        url['param'] = []
        if (field.data.page_id != undefined) {
          url['param'].push(`page_id=${field.data.page_id}`)
        }
        if (field.data.query) {
          url['param'].push(`byColumn=1`)
          for (const key in field.data.query) {
            url['param'].push(key + '=' + field.data.query[key])
          }
        }
        url['param'].push(`no_limit=true`)
        url['param'].push(`lookups_needed=` + (field.data.lookups_needed || 0))
        url['param'].push(`min_max_needed=0`)
        Vue.set(state.collections, field.data.collection_id, {
          by_brand: {},
          response: undefined,
          last_success_load_time: 0,
          being_loaded: false,
          keep_on_page_change: field.data.keep_on_page_change,
          data: [],
          by_id: undefined,
          params: url['param'],
          url: `${url['url']}?${url['param'].join('&')}`,
        })
      }
      if (field.data.brand_required) {
        if (!currentBrandId) {
          utils.generate_error(
            `${field.field_id} collection requires brand, but brand is not in context`
          )
        }
        if (
          !(
            currentBrandId in
            state.collections[field.data.collection_id].by_brand
          )
        ) {
          url = {}
          url[
            'url'
          ] = `${api_root_url}/${currentBrandId}${model}/${field.data.collection_id}`
          if (field.data.entities) {
            for (const key in field.data.entities) {
              url['url'] += '/' + key + '/' + field.data.entities[key]
            }
          }
          url['param'] = []

          if (field.data.page_id != undefined) {
            url['param'].push(`page_id=${field.data.page_id}`)
          }
          if (field.data.query) {
            url['param'].push(`byColumn=1`)
            for (const key in field.data.query) {
              url['param'].push(key + '=' + field.data.query[key])
            }
          }
          url['param'].push(`no_limit=true`)
          url['param'].push(
            `lookups_needed=` + +(field.data.lookups_needed || 0)
          )
          url['param'].push(`min_max_needed=0`)
          Vue.set(
            state.collections[field.data.collection_id].by_brand,
            currentBrandId,
            {
              by_store: {},
              response: undefined,
              last_success_load_time: 0,
              being_loaded: false,
              data: [],
              keep_on_page_change: field.data.keep_on_page_change,
              by_id: undefined,
              params: url['param'],
              url: `${url['url']}?${url['param'].join('&')}`,
            }
          )
        }
        if (field.data.store_required) {
          if (!currentStoreId) {
            utils.generate_error(
              `${field.field_id} collection requires store, but store is not in context`
            )
          }
          if (
            !(
              currentStoreId in
              state.collections[field.data.collection_id].by_brand[
                currentBrandId
              ].by_store
            )
          ) {
            url = {}
            url[
              'url'
            ] = `${api_root_url}/${currentBrandId}/${currentStoreId}${model}/${field.data.collection_id}`
            if (field.data.entities) {
              for (const key in field.data.entities) {
                url['url'] += '/' + key + '/' + field.data.entities[key]
              }
            }
            url['param'] = []

            if (field.data.page_id != undefined) {
              url['param'].push(`page_id=${field.data.page_id}`)
            }
            if (field.data.query) {
              url['param'].push(`byColumn=1`)
              for (const key in field.data.query) {
                url['param'].push(key + '=' + field.data.query[key])
              }
            }
            url['param'].push(`no_limit=true`)
            url['param'].push(
              `lookups_needed=` + +(field.data.lookups_needed || 0)
            )
            url['param'].push(`min_max_needed=0`)
            Vue.set(
              state.collections[field.data.collection_id].by_brand[
                currentBrandId
              ].by_store,
              currentStoreId,
              {
                last_success_load_time: 0,
                being_loaded: false,
                response: undefined,
                data: [],
                keep_on_page_change: field.data.keep_on_page_change,
                by_id: undefined,
                params: url['param'],
                url: `${url['url']}?${url['param'].join('&')}`,
              }
            )
          }
        }
      }
    },
    SET_COLLECTION_LOAD_STARTED: (state, { field, actual_record }) => {
      actual_record.being_loaded = true
    },
    SET_COLLECTION_LOAD_SUCCESS: (
      state,
      { response, field, actual_record }
    ) => {
      response = Object.freeze(response)
      //actual_record.response = response
      actual_record.data = response.data ? response.data : response
      actual_record.by_id = undefined
      actual_record.being_loaded = false
      actual_record.last_success_load_time = Date.now()
    },
    SET_COLLECTION_LOAD_FAILURE: (state, { field, actual_record }) => {
      actual_record.being_loaded = false
      //TODODISCUSS - we do only two attempts to load collection
      if (actual_record.last_success_load_time == -1) {
        actual_record.last_success_load_time = Date.now()
      } else {
        actual_record.last_success_load_time = -1
      }
    },
  },
  actions: {
    resetCollections({ commit }) {
      commit('SET_COLLECTION_TIMERS_TO_1970')
    },
    resetCollectionByCollectionId({ commit }, collectionId) {
      commit('RESET_COLLECTION_BY_ID', collectionId)
    },
    getDataWithForceReload({ dispatch, getters }, field) {
      return dispatch('executeGetData', {
        field: field,
        forced_reload: true,
        version: getters.getVersion(field),
      })
    },
    getData({ dispatch, getters }, field) {
      return dispatch('executeGetData', {
        field: field,
        forced_reload: false,
        version: getters.getVersion(field),
      })
    },
    executeGetData(
      { state, dispatch, commit, getters },
      { field, forced_reload, version }
    ) {
      async function perform_load(actual_record, field) {
        var url = actual_record.url
        let authHeader = axios.defaults.headers.Authorization
        if (version && !forced_reload) {
          const glue = url.includes('?') ? '&' : '?'
          url =
            url.replace(getters.api_root_url, getters.api_cached_root_url) +
            `${glue}fetch_version=${version}`
          authHeader = 'guest'
        }
        await axios
          .get(url, {
            transformRequest: (data, headers) => {
              headers.Authorization = authHeader
              return data
            },
          })
          .then((response) => {
            commit('SET_COLLECTION_LOAD_SUCCESS', {
              response: response.data,
              field,
              actual_record,
            })
            if (field.data.after_load_dispatch) {
              dispatch(field.data.after_load_dispatch, response.data)
            }
          })
          .catch((err) => {
            commit('SET_COLLECTION_LOAD_FAILURE', { field, actual_record })
            // utils.process_error(err.response.data);
          })
      }

      if (
        !forced_reload ||
        find_actual_record(state, getters, field) === undefined
      ) {
        commit('SET_COLLECTION_INITIAL_IF_REQUIRED', {
          api_root_url: getters.api_root_url,
          field,
          currentBrandId: field.data.brand_id || getters.currentBrandId,
          currentStoreId: field.data.store_id || getters.currentStoreId,
        })
      }
      var actual_record = find_actual_record(state, getters, field)
      // console.log(field, 'field', actual_record)

      if (
        Date.now() - actual_record.last_success_load_time >
          CONST.COLLECTION_RELOAD_TIME ||
        forced_reload
      ) {
        if (actual_record.being_loaded == false) {
          if (!forced_reload) {
            commit('SET_COLLECTION_LOAD_STARTED', { field, actual_record })
          }
          return perform_load(actual_record, field)
        }
      }
      return new Promise((resolve, reject) => resolve())
    },
  },
  getters: {
    getVersion: (state, getters) => (field) => {
      let version = getters.findVersion(field)
      if (version) {
        const deps = getters.findDependencies(field)
        if (deps) {
          version += ',' + deps
        }
      }
      return version
    },
    findCollectionId: (state, getters) => (field) => {
      var collection_remaps = {
        root_stores: 'stores',
        new_style_root_delivery_areas: 'new_style_store_delivery_areas',
        root_order_discounts: 'brand_order_discounts',
        brand_item_discounts: 'brand_item_discount',
        brand_web_translations: 'brand_translations',
        new_style_brand_delivery_areas: 'new_style_store_delivery_areas',
      }

      return (
        collection_remaps[field.data.collection_id] || field.data.collection_id
      )
    },
    findVersion: (state, getters) => (field) => {
      const collection_id = getters.findCollectionId(field)
      var ver = getters.all_core_versions
      if (ver && ver[collection_id] !== undefined) {
        return ver[collection_id]
      }
      return undefined
    },
    findDependencies: (state, getters) => (field) => {
      const collection_id = getters.findCollectionId(field)
      const apiDependencyVersions = getters.all_core_versions_deps
      let deps = []

      if (apiDependencyVersions && apiDependencyVersions[collection_id]) {
        apiDependencyVersions[collection_id]
          .sort()
          .forEach((depCollectionId) => {
            const depVersion = getters.findVersion({
              data: { collection_id: depCollectionId },
            })
            if (depVersion) {
              deps.push(
                depCollectionId +
                  ',' +
                  getters.findVersion({
                    data: { collection_id: depCollectionId },
                  })
              )
            }
          })
      }
      return deps.length ? deps.join(',') : ''
    },

    //Required for complex inventory lookups
    //NOTE - Never call this if you haven't tried to initalize the data first
    collection_being_loaded: (state, getters) => (field) => {
      var actual_record = find_actual_record(state, getters, field)

      if (!actual_record) {
        utils.generate_error(
          `Checking collection load for unknown record for ${field.field_id}`
        )
        return true
      }
      return actual_record.being_loaded
    },
    get_actual_record: (state, getters) => (field) =>
      find_actual_record(state, getters, field),
    find_in_collection_data: (state, getters) => (field, item_id) => {
      if (field.data.filter.length == 0) {
        var actual_record = find_actual_record(state, getters, field)
        if (actual_record == undefined) {
          var data = getters.get_collection_data(field)
          return data.find(
            (item) => item[field.data.collection_store_field_name] == item_id
          )
        }
        if (actual_record.being_loaded) {
          console.log(
            'wait... object being loaded, recheck promise fullfilment'
          )
        } else {
          if (actual_record && actual_record.by_id == undefined) {
            var res = {}
            for (var item of actual_record.data) {
              res[item[field.data.collection_store_field_name]] = item
            }
            actual_record.by_id = res
          }
          return actual_record.by_id[item_id]
        }
      } else {
        var data = getters.get_collection_data(field)
        return data.find(
          (item) => item[field.data.collection_store_field_name] == item_id
        )
      }
    },
    find_in_collection_data_by_brand_id:
      (state, getters) => (field, brand_id) => {
        return getters.find_in_collection_data_by_key(
          field,
          'brand_id',
          brand_id
        )
      },
    find_in_collection_data_by_store_id:
      (state, getters) => (field, store_id) => {
        return getters.find_in_collection_data_by_key(
          field,
          'store_id',
          store_id
        )
      },
    find_in_collection_data_by_key: (state, getters) => (field, key, value) => {
      if (field.data.filter.length == 0) {
        var actual_record = find_actual_record(state, getters, field)

        if (actual_record == undefined) {
          var data = getters.get_collection_data(field)
          return data.filter((item) => item[key] == value)
        }

        if (actual_record && actual_record[key] == undefined) {
          var res = {}

          for (var item of actual_record.data) {
            if (!res[item[key]]) {
              res[item[key]] = []
            }
            res[item[key]].push(item)
          }

          actual_record[key] = res
        }
        return actual_record[key][value]
      } else {
        var collection_data = getters.get_collection_data(field)
        return collection_data.filter((item) => item[key] == value)
      }
    },
    // NOTE - Never call this if you haven't tried to initalize the data first
    get_collection_data:
      (state, getters) => (field, all_models, items_to_exclude) => {
        var actual_record = find_actual_record(state, getters, field)
        if (!actual_record) {
          utils.generate_error(
            `Requesting collection load for which was not requested for ${field.data.collection_id}`
          )
          return []
        }
        if (!Array.isArray(actual_record.data)) {
          return actual_record.data
        }
        var filtered_collection
        for (var filter of field.data.dependent_filters) {
          if (filter.type == 'dep_fixed_collection') {
            if (filter.field) {
              filtered_collection = filter.fixed_collection.filter(
                (collection_item) =>
                  collection_item[filter.should_match] ==
                  all_models[filter.field]
              )
            } else {
              filtered_collection = filter.fixed_collection
            }
          }
        }

        var results = actual_record.data.filter((item) => {
          for (var filter of field.data.filter) {
            if (filter.type == 'eq' && item[filter.attribute] != filter.value) {
              return false
            }
            if (
              filter.type == 'eq_in' &&
              filter.value.find((el) => el == item[filter.attribute]) ==
                undefined
            ) {
              return false
            }
            if (
              filter.type == 'includes' &&
              !item[filter.attribute].includes(filter.value)
            ) {
              return false
            }
            if (
              filter.type == 'neq' &&
              item[filter.attribute] == filter.value
            ) {
              return false
            }
          }
          for (var filter of field.data.dependent_filters) {
            //TODOIMPR more error handling
            if (
              filter.type == 'eq_to_field_val' &&
              all_models[filter.field] != item[filter.attribute]
            ) {
              return false
            }
            if (filter.type == 'dep_fixed_collection') {
              if (
                !filtered_collection.find(
                  (element) =>
                    element[filter.should_match_attribute] ==
                    item[filter.attribute]
                )
              ) {
                return false
              }
            }
            if (
              filter.type == 'contain_field_val' &&
              !item[filter.attribute].includes(all_models[filter.field])
            ) {
              return false
            }
            if (filter.type == 'in_context') {
              if (filter.context == 'brand') {
                if (getters.currentBrand) {
                  if (
                    !getters.currentBrand[filter.context_attr].includes(
                      item[filter.attribute]
                    )
                  ) {
                    return false
                  }
                } else {
                  utils.generate_error(
                    'Working with in_context brand without brand'
                  )
                  return false
                }
              } else if (filter.context == 'store') {
                if (getters.currentStore) {
                  if (
                    !getters.currentStore[filter.context_attr].includes(
                      item[filter.attribute]
                    )
                  ) {
                    return false
                  }
                } else {
                  utils.generate_error(
                    'Working with in_context store without store'
                  )
                  return false
                }
              }
            }
          }
          return true
        })
        var final_results = results.sort(
          utils.sort_field_by_attributes_function(
            field.data.collection_sort_by_field_name
          )
        )

        return final_results
      },
  },
}
